import {h, Fragment} from "preact"
import { usePagination, useActions } from '@nosto/preact'

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({
        width: 5,
    })

    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: (e) => {
                e.preventDefault()
                updateSearch({ products: { from } })
                // Scroll to the products first row
                const serpElement = document.querySelector('.ns-serp')
                const header = document.querySelector('x-header.is-hidden')

                if (serpElement) {
                    if (header) {
                        // If header is hidden, adjust scroll position by header height
                        const headerHeight = header.offsetHeight
                        const serpRect = serpElement.getBoundingClientRect()
                        const scrollPosition = window.pageYOffset + serpRect.top - headerHeight
                        window.scrollTo(0, scrollPosition)
                    } else {
                        // Standard scrolling if no hidden header
                        serpElement.scrollIntoView({ behavior: 'auto', block: 'start' })
                    }
                } else {
                    // Fallback to scrolling to top if element not found
                    scrollTo(0, 0)
                }
            },
            href: simulateUpdateSearch({ products: { from } }).url,
        }
    }

    return (
        <>
            {prev && (
                <facet-link class="contents">
                    <a
                        class="pagination__link h6"
                        rel="prev"
                        aria-label="Previous page"
                        {...pageLinkProps(prev)}>
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            fill="none"
                            width="11"
                            class="icon icon-chevron-left icon--direction-aware"
                            viewBox="0 0 10 10">
                            <path d="M7 1 3 5l4 4" stroke="currentColor" stroke-linecap="square"></path>
                        </svg>
                    </a>
                </facet-link>
            )}

            {first && (
                <>
                    <facet-link class="contents">
                        <a class="pagination__link h6" aria-label="First page" {...pageLinkProps(first)}>
                            {first.page}
                        </a>
                    </facet-link>
                    <span class="pagination__link pagination__link--disabled h6">...</span>
                </>
            )}

            {pages.map((page) => (
                <facet-link class="contents" key={page.page}>
                    <a
                        class={`pagination__link h6 ${page.current ? 'pagination__link--disabled' : ''}`}
                        aria-label={`Go to page ${page.page}`}
                        aria-current={page.current ? 'page' : undefined}
                        {...pageLinkProps(page)}>
                        {page.page}
                    </a>
                </facet-link>
            ))}

            {last && (
                <>
                    <span class="pagination__link pagination__link--disabled h6">...</span>
                    <facet-link class="contents">
                        <a class="pagination__link h6" aria-label="Last page" {...pageLinkProps(last)}>
                            {last.page}
                        </a>
                    </facet-link>
                </>
            )}

            {next && (
                <facet-link class="contents">
                    <a class="pagination__link h6" rel="next" aria-label="Next page" {...pageLinkProps(next)}>
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            fill="none"
                            width="11"
                            class="icon icon-chevron-right icon--direction-aware"
                            viewBox="0 0 10 10">
                            <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
                        </svg>
                    </a>
                </facet-link>
            )}
        </>
    )
}
